import React, { useEffect, useState, useRef } from "react";
import Webcam from "react-webcam";

const DynamicResolutionWebcam = () => {
  const webcamRef = useRef(null);
  const [videoConstraints, setVideoConstraints] = useState(null);
  const [loading, setLoading] = useState(true);
  const [res,setRes]=useState(null);

  // Function to get the highest camera resolution
  const getHighestResolution = async () => {
    try {
      // Access the user's video stream
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
        audio: false,
      });

      // Get the video track and its capabilities
      const videoTrack = stream.getVideoTracks()[0];
      const capabilities = videoTrack.getCapabilities();
      console.log(capabilities,"22")
      // Get the max width and height from capabilities
      const maxWidth = capabilities.width?.max || 1920; // Fallback to 1920 if unavailable
      const maxHeight = capabilities.height?.max || 1080; // Fallback to 1080 if unavailable
      const maxFrameRate = capabilities.frameRate ? capabilities.frameRate.max : 30;

      console.log(`Max resolution supported: ${maxWidth}x${maxHeight}`);
      setRes(`Max resolution supported: ${maxWidth}x${maxHeight}`)

      // Stop the video track to free up the camera
      videoTrack.stop();

      // Return the maximum resolution
      return { width: maxWidth, height: maxHeight, frameRate :maxFrameRate};
    } catch (error) {
      console.error("Error accessing camera capabilities:", error);
      return { width: 1920, height: 1080 }; // Default resolution if error occurs
    }
  };

  // Setup camera with the highest available resolution
  useEffect(() => {
    const setupCamera = async () => {
      const resolution = await getHighestResolution();
      setVideoConstraints({
        facingMode: "environment",
        width: { ideal: resolution.width },
        height: { ideal: resolution.height },
        frameRate: { ideal : resolution.frameRate},
        audio: true,
      });
      setLoading(false); // Camera setup completed
    };

    setupCamera();
  }, []);

  return loading ? (
    <div>Loading camera...</div>
  ) : (
    <>
     <Webcam
      ref={webcamRef}
      audio={true}
      muted={true}
      screenshotFormat="image/jpeg"
      screenshotQuality={1}
      videoConstraints={videoConstraints}
      height="100%"
      width="100%"
      className="webcam"
      style={{
        position: "absolute",
        textAlign: "center",
        zIndex: 8,
        right: 0,
        objectFit: "cover",
        overflow: "hidden",
      }}
    />
    <p
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "8px 8px",
      gap: "10px",
      position: "absolute",
      width: "auto",
      height: "33px",
      left: "15px",
      top: "24px",
      background: "rgba(255, 255, 255, 0.6)",
      borderRadius: "8px",
      fontFamily: "'Montserrat', sans-serif",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "157%",
      textAlign: "center",
      letterSpacing: "0.1px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      color: "black",
      zIndex: 100,
      "@media (max-width: 900px)and (orientation: landscape)": {
        fontSize: "12px",
      },
    }}
  >

  {res}  

  </p>
    </>
   
  );
};

export default DynamicResolutionWebcam;
